module.exports = __webpack_public_path__ + "media/images/logo-53b63f0868de6e25eadda996200718f2.svg";